import {
  getLibraryReturnHref,
  librarySectionFromBasePath,
} from "@/lib/library-search-snapshot";

export type SectionSubNavLabelKey = "library" | "redaction" | "statistics";

export interface SectionSubNavItem {
  slug: SectionSubNavLabelKey;
  labelKey: SectionSubNavLabelKey;
}

export const sectionSubNavItems: SectionSubNavItem[] = [
  { slug: "library", labelKey: "library" },
  { slug: "redaction", labelKey: "redaction" },
  { slug: "statistics", labelKey: "statistics" },
];

export function getSectionSubNavHref(
  basePath: string,
  slug: SectionSubNavItem["slug"],
): string {
  if (slug === "library") {
    const section = librarySectionFromBasePath(basePath);
    if (section) return getLibraryReturnHref(section);
  }

  return `${basePath}/${slug}`;
}

export function isSectionSubNavActive(
  pathname: string,
  basePath: string,
  slug: SectionSubNavItem["slug"],
): boolean {
  const href = getSectionSubNavHref(basePath, slug);

  if (slug === "library") {
    return pathname === basePath || pathname === href;
  }

  return pathname === href || pathname.startsWith(`${href}/`);
}
